/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotStatusFinished_org = {
    readonly nextDefragTime: {
        readonly millis?: unknown | null | undefined;
    } | null;
    readonly tailoredDefragCardSummary: ({
        readonly __typename: "TailoredDefragCardSummary";
        readonly yourEventMoves: ReadonlyArray<{
            readonly event: {
                readonly title: string | null;
            };
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "AutopilotStatusFinished_org";
};
export type AutopilotStatusFinished_org$data = AutopilotStatusFinished_org;
export type AutopilotStatusFinished_org$key = {
    readonly " $data"?: AutopilotStatusFinished_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotStatusFinished_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutopilotStatusFinished_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nextDefragTime",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "millis",
                            "storageKey": null
                        }
                    ],
                    "type": "DefragTime",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "tailoredDefragCardSummary",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DefragExplainedMove",
                            "kind": "LinkedField",
                            "name": "yourEventMoves",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "event",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "title",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "TailoredDefragCardSummary",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'd4480d19d356390b574807706f797275';
export default node;
